import { Host, h } from "@stencil/core";
export class ChSidebarMenuListItem {
    constructor() {
        this.itemIconSrc = undefined;
        this.autoColor = false;
        this.uncollapsed = false;
        this.collapsable = false;
        this.listTypeItem = undefined;
    }
    /**
     * Emmits the item id
     */
    itemClickedEvent;
    el;
    componentWillLoad() {
        // SET THE TPYE OF ITEM
        if (this.el.parentElement.classList.contains("list-one")) {
            this.listTypeItem = "one";
        }
        else if (this.el.parentElement.classList.contains("list-two")) {
            this.listTypeItem = "two";
        }
        else {
            this.listTypeItem = "three";
        }
        // SET COLLAPSABLE OR NOT
        if (this.el.querySelector("ch-sidebar-menu-list") !== null) {
            this.collapsable = true;
        }
    }
    itemClicked() {
        const itemId = this.el.getAttribute("id");
        this.itemClickedEvent.emit({ "item-id": itemId });
    }
    firstListItemIcon() {
        if (this.itemIconSrc !== undefined) {
            return this.itemIconSrc;
        }
    }
    listItemContent() {
        if (this.listTypeItem === "one") {
            return [
                h("div", { class: "main-container", onClick: this.itemClicked.bind(this) }, h("div", { class: "left-container" }, h("span", { class: "icon custom-icon" }, h("ch-icon", { src: this.firstListItemIcon(), style: {
                        "--icon-size": "20px",
                        "--icon-color": `var(--first-list-icon-color)`
                    }, "auto-color": this.autoColor })), h("span", { class: "text" }, h("slot", null))), this.collapsable ? (h("span", { class: "icon arrow-icon" }, h("div", { part: "collapse-item-icon" }))) : null),
                h("slot", { name: "list" })
            ];
        }
        if (this.listTypeItem === "two") {
            return [
                h("div", { class: "main-container", onClick: this.itemClicked.bind(this) }, this.collapsable ? (h("span", { class: "icon arrow-icon" }, h("div", { part: "collapse-item2-icon" }))) : null, h("span", { class: "text" }, h("slot", null))),
                h("slot", { name: "list" })
            ];
        }
        if (this.listTypeItem === "three") {
            return (h("div", { class: "main-container", onClick: this.itemClicked.bind(this) }, h("span", { class: "text" }, h("slot", null))));
        }
    }
    render() {
        return (h(Host, { class: {
                item: true,
                collapsable: this.collapsable,
                uncollapsed: this.uncollapsed,
                "list-one__item": this.listTypeItem === "one",
                "list-two__item": this.listTypeItem === "two",
                "list-three__item": this.listTypeItem === "three"
            } }, this.listItemContent()));
    }
    static get is() { return "ch-sidebar-menu-list-item"; }
    static get encapsulation() { return "shadow"; }
    static get originalStyleUrls() {
        return {
            "$": ["ch-sidebar-menu-list-item.scss"]
        };
    }
    static get styleUrls() {
        return {
            "$": ["ch-sidebar-menu-list-item.css"]
        };
    }
    static get assetsDirs() { return ["sidebar-menu-list-item-assets"]; }
    static get properties() {
        return {
            "itemIconSrc": {
                "type": "string",
                "mutable": false,
                "complexType": {
                    "original": "string",
                    "resolved": "string",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "The first list item icon (optional)"
                },
                "attribute": "item-icon-src",
                "reflect": false
            },
            "autoColor": {
                "type": "boolean",
                "mutable": false,
                "complexType": {
                    "original": "boolean",
                    "resolved": "boolean",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "If enabled, the icon will display its inherent/natural color"
                },
                "attribute": "auto-color",
                "reflect": true,
                "defaultValue": "false"
            },
            "uncollapsed": {
                "type": "boolean",
                "mutable": false,
                "complexType": {
                    "original": "boolean",
                    "resolved": "boolean",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "If this attribute is present the item will be initially uncollapsed"
                },
                "attribute": "uncollapsed",
                "reflect": false,
                "defaultValue": "false"
            }
        };
    }
    static get states() {
        return {
            "collapsable": {},
            "listTypeItem": {}
        };
    }
    static get events() {
        return [{
                "method": "itemClickedEvent",
                "name": "itemClickedEvent",
                "bubbles": true,
                "cancelable": true,
                "composed": true,
                "docs": {
                    "tags": [],
                    "text": "Emmits the item id"
                },
                "complexType": {
                    "original": "any",
                    "resolved": "any",
                    "references": {}
                }
            }];
    }
    static get elementRef() { return "el"; }
}
//# sourceMappingURL=ch-sidebar-menu-list-item.js.map
